import { API, graphqlOperation } from "aws-amplify";
import * as mutations from "./../graphql/mutations";
export class CustomField {
  constructor() {}

  static async getCustomFields(id) {
    const getEventCollectUserData = /* GraphQL */ `
      query GetEventCollectUserData($id: ID!) {
        getEventCollectUserData(id: $id) {
          id
          questionType
          label
          validation
          fieldType
          internalUse
          success
          error
          hint
          createdAt
          isDeleted
          eventCollectUserDataOptions {
            items {
              id
              options
            }
          }
        }
      }
    `;

    const result = await API.graphql(
      graphqlOperation(getEventCollectUserData, {
        id: id
      })
    );
    return result.data.getEventCollectUserData;
  }

  static async createBespokeQuestion(
    eventId,
    {
      questionType,
      label,
      validation,
      fieldType,
      success,
      error,
      hint,
      internalUse
    }
  ) {
    const result = await API.graphql(
      graphqlOperation(mutations.createEventCollectUserData, {
        input: {
          label: label,
          validation: validation,
          fieldType: fieldType,
          questionType: questionType,
          internalUse: internalUse ? true : false,
          success: success,
          error: error,
          hint: hint,
          createdAt: new Date().toISOString(),
          isDeleted: 0,
          eventCollectUserDataEventId: eventId
        }
      })
    );
    return result.data.createEventCollectUserData;
  }
}
